// 事業所をグループ（サービス種別）ごとにまとめる。
// offices は order 順で渡される前提。グループ未設定は group: '' として扱う。
// groupOrder: 管理画面で指定したグループ表示順（名前の配列）。
export const groupOffices = (offices = [], groupOrder = []) => {
  const groups = [];
  const map = new Map();
  offices.forEach((office) => {
    const key = office.group && office.group.trim() ? office.group.trim() : '';
    if (!map.has(key)) {
      const entry = { group: key, items: [] };
      map.set(key, entry);
      groups.push(entry);
    }
    map.get(key).items.push(office);
  });

  // 並び替え：未分類('')は先頭、名前付きグループは groupOrder 順、
  // groupOrder に無いグループは元の出現順で後ろに。
  const order = Array.isArray(groupOrder) ? groupOrder : [];
  const rank = (entry, idx) => {
    if (!entry.group) return -1; // 未分類を先頭
    const i = order.indexOf(entry.group);
    return i === -1 ? order.length + idx : i;
  };
  return groups
    .map((entry, idx) => ({ entry, idx, r: rank(entry, idx) }))
    .sort((a, b) => (a.r !== b.r ? a.r - b.r : a.idx - b.idx))
    .map((x) => x.entry);
};
